<form [formGroup]="tmprForm" *ngIf="tmprForm" (ngSubmit)="onSubmit()" class="myform">
  <div class="p-5">
    <div class="flex justify-center items-baseline flex-wrap">
      <!-- <div fxLayout="row" fxLayout.xs="column" fxLayoutWrap  fxLayoutGap="5%" fxLayoutAlign="center"> -->
      <div class="flex m-2">
        <mat-form-field [hideRequiredMarker]="true">
          <mat-label>Gamma (ɣ) &nbsp; value</mat-label>
          <input matInput formControlName="gammaVal" autocomplete="off">
          <mat-error *ngIf="tmprForm.invalid && tmprForm.touched">
            <span class="myerror">1.0 &lt; ɣ &le; 1.67</span>
          </mat-error>
        </mat-form-field>
      </div>
  
      <div class="flex m-2">
        <mat-form-field [hideRequiredMarker]="true">
          <mat-label>Temperature ratio</mat-label>
            <input matInput formControlName="tmprVal" autocomplete="off">
            <mat-error *ngIf="tmprForm.invalid && tmprForm.touched">
              <span class="myerror"> T / T<sub>t</sub> < 1 </span>
              <!-- <span class="myerror"> <ttt></ttt> < 1</span> -->
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      
      <div class="sbmtArea flex justify-center items-baseline flex-wrap">
        <button mat-raised-button type="submit" [disabled]="tmprForm.invalid">Calculate</button>
      </div>
    </div>
  </form>
      
  <div class="flex justify-center items-baseline flex-wrap" *ngIf="tBool">
    <table>
      <tr>
        <td>
          <img src="assets/math/mach_b.svg" alt="">
        </td>
            <!-- <td><mach></mach></td> -->
            <span class="asana2">
              <td> {{ isenMach()}} </td>
            </span>
            
            </tr>
            <tr>
              <td>
                <img src="assets/math/ppt_b.svg" alt="">
              </td>
              <!-- <td><ppt></ppt></td> -->
              <td>
                <span class="asana2">
                  {{ isenp_pt() | number:'.1-5' }}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <img src="assets/math/aas_b2.svg" alt="">
              </td>
              <!-- <td><aas></aas></td> -->
                <span class="asana2">
                  <td>{{ isenA_As() | number:'.1-5'}}</td>
                </span>
            </tr>
            <tr>
              <td>
                <img src="assets/math/paptas_b2.svg" alt="">
              <td>
              <!-- <td><paptas></paptas></td> -->
              <span class="asana2">
                {{ isenpA_ptAstar()  | number:'.1-5'  }}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <!-- <pm></pm> -->
                <img src="assets/math/pm_b2.svg" alt="">
              </td>


              <td>
                <span class="asana2">

                
                {{ isenpm() | number:'.1-5' }}
              </span>
              
              </td>

            </tr>
            <tr>
              <td>
                <img src="assets/math/ma_b.svg" alt="">
              </td>
              <!-- <td><machang></machang></td> -->
              <td>
                <span class="asana2">
                  {{ isenmach_angle() | number:'.1-5' }}
                </span>
              
              </td>
            </tr>
            <tr>
              <td><span matTooltip="Optimal thrust coefficient" matTooltipPosition="left">
                <!-- <cfopt></cfopt> -->
                <img src="assets/math/cfopt_b3.svg" alt="">

              </span></td>
              <td>
                <span class="asana2">

                  {{isen_cfopt() | number:'.1-5' }}
                </span>
                </td>
            </tr>
      
            <tr>
              <td>
                <img src="assets/math/rhorhot_b.svg" alt="">
              </td>
              <!-- <td><rhot></rhot></td> -->
              <td>
                <span class="asana2">

                {{ isen_rhot() | number:'.1-5' }}
              </span>
              </td>
      
            </tr>
            </table>
        </div>
      